import axios from "axios";
import { startLoading, stopLoading } from "./loading";

function shouldSkipLoading(url = "") {
  return /FrontEnd_Rating|rating\/check/i.test(url);
}

axios.interceptors.request.use((config) => {
  config.skipLoading = shouldSkipLoading(config.url);
  if (!config.skipLoading) {
    startLoading();
  }
  return config;
});

function finish(config) {
  if (config && !config.skipLoading) {
    stopLoading();
  }
}

axios.interceptors.response.use(
  (response) => {
    finish(response.config);
    return response;
  },
  (error) => {
    finish(error.config);
    return Promise.reject(error);
  }
);
